<template>
    <section class="hero">
        <div class="hero-body">
            <div class="container">
                <h1 class="title">
                    Error 503
                </h1>
                <h2 class="subtitle">
                    Service Unavailable
                </h2>
            </div>
        </div>
    </section>
</template>

<script>
    import configData from '../../config'

    export default {
        name: 'error-503',

        created: function() {
            window.location.href = this.error503Url;
        },

        computed: {
            error503Url: function() {
                return configData().errorsUrl.error503
            }
        }
    }
</script>



// WEBPACK FOOTER //
// 503.vue?59286841